// @aiContributed-2025-10-28
import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedBudgetAndBidsStepWithI18n =
  () => import(/* webpackChunkName: 'budget-and-bids-step.async' */'./budget-and-bids-step')
    .then(({ BudgetAndBidsStepWithI18n }) => BudgetAndBidsStepWithI18n);

const DelayedBudgetAndBidsLazyRepository =
  () => import(/* webpackChunkName: 'budget-and-bids-lazy-repository.async' */'./budget-and-bids-lazy-repository')
    .then(({ BudgetAndBidsLazyRepositoryWithI18n }) => BudgetAndBidsLazyRepositoryWithI18n);

export const SearchCampaignBudgetAndBidsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_BUDGET_AND_BIDS,
  view: DelayedBudgetAndBidsStepWithI18n,
  repository: DelayedBudgetAndBidsLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
  viewProps: {
    isSignup: true,
  },
};
